/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  NotificationDefault,
  PushNotificationDeleteArgs,
  PushNotificationsArgs,
  notificationsApi,
} from '../services';

interface PushNotificationsState {
  isFetched: boolean;
  pushNotifications: NotificationDefault[];
  page: number;
  hasNextPage: boolean;
}

const initialState: PushNotificationsState = {
  isFetched: false,
  pushNotifications: [],
  page: 0,
  hasNextPage: false,
};

const getPushNotificationsHandler = async (args: PushNotificationsArgs, { dispatch }: any) => {
  return dispatch(notificationsApi.endpoints.pushNotifications.initiate({ ...args })).unwrap();
};

export const getPushNotifications = createAsyncThunk(
  'getPushNotifications',
  getPushNotificationsHandler
);

export const loadMorePushNotifications = createAsyncThunk(
  'getPushNotifications/loadMore',
  getPushNotificationsHandler
);

export const deletePushNotification = createAsyncThunk(
  'deletePushNotification',
  async (args: PushNotificationDeleteArgs, { dispatch }) => {
    const deleted = await dispatch(
      notificationsApi.endpoints.pushNotificationDelete.initiate(args)
    ).unwrap();
    return { ...args, deleted };
  }
);

const PushNotificationsSlice = createSlice({
  name: 'pushNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPushNotifications.pending, (state) => {
        state.isFetched = false;
      })
      .addCase(getPushNotifications.fulfilled, (state, action) => {
        const { items, pageInfo } = action.payload;
        const { page, hasNextPage } = pageInfo;

        state.isFetched = true;
        state.pushNotifications = items;
        state.page = page;
        state.hasNextPage = hasNextPage;
      })
      .addCase(loadMorePushNotifications.fulfilled, (state, action) => {
        const { items, pageInfo } = action.payload;
        const { page, hasNextPage } = pageInfo;

        state.pushNotifications.push(...items);
        state.page = page;
        state.hasNextPage = hasNextPage;
      })
      .addCase(deletePushNotification.fulfilled, (state, action) => {
        const { deleted, notificationId } = action.payload;

        if (!deleted) {
          return;
        }

        state.pushNotifications = state.pushNotifications.filter(({ id }) => id !== notificationId);
      });
  },
});

export default PushNotificationsSlice.reducer;
